<div class="d-flex">
  <div class="nav-flex-column nav-pills me-3 tablist fw-bold" role="tablist">
    <button class="nav-link" [ngClass]="activeTab === 'model' ? 'bg-primary text-white' : 'bg-info'" (click)="selectTab('model')">
      Select By Model
    </button>
  </div>
</div>
<div class="form-container">
  @if (!isLoading() && activeTab === 'condition') {
    <div class="dynamic-form-builder">
      <!--Select by operating condition-->
    </div>
  }

  @if (!isLoading() && activeTab === 'model') {
    <div class="dynamic-form-builder">
      <app-dynamic-form-model
        [formFields]="fields"
        [tab]="activeTab"
        [models]="models"
        (formValueChanged)="handleFormValueChanged($event)"
        (modelSelected)="onModelSelected($event)"></app-dynamic-form-model>
    </div>
  }
</div>
<div class="submit-button d-flex justify-content-end align-content-start">
  <button type="button" class="btn btn-primary p-2 trigger-submit" (click)="handleSubmit()" [disabled]="!allRequiredFieldsPresent">
    Submit
  </button>
</div>

<!--
Inner tabs wrapper — always in the DOM so BlowerFilterTableComponent subscribes
to submitClicked$ before submit fires (Subject won't replay missed events).
Visibility is toggled via [hidden] rather than *ngIf.
-->
<div [hidden]="!hasSubmitted">
  <!-- Tab buttons -->
  <div class="inner-tabs-header d-flex flex-row mt-2 mb-0">
    <button
      class="nav-link inner-nav-link"
      [ngClass]="activeInnerTab === 'results' ? 'bg-primary text-white' : 'bg-info'"
      (click)="selectInnerTab('results')">
      Results
    </button>
    <button
      class="nav-link inner-nav-link"
      [ngClass]="activeInnerTab === 'graphs' ? 'bg-primary text-white' : 'bg-info'"
      (click)="selectInnerTab('graphs')">
      Graphs
    </button>
  </div>

  <!-- Results tab: [hidden] keeps the component alive so table data is never lost -->
  <div [hidden]="activeInnerTab !== 'results'">
    @if (activeTab === 'model') {
      <div>
        <app-blower-filter-table
          [tab]="activeTab"
          [sensorValues]="transformData"
          (modelEmitter)="onDefaulModelName($event)"></app-blower-filter-table>
      </div>
    }
    @if (activeTab === 'condition') {
      <div>
        <app-blower-filter-table
          [tab]="activeTab"
          [sensorValues]="transformData"
          (modelEmitter)="onDefaulModelName($event)"></app-blower-filter-table>
      </div>
    }
  </div>

  <!-- Graphs tab: [hidden] keeps echarts instances alive across tab switches -->
  <div [hidden]="activeInnerTab !== 'graphs'">
    <app-graph></app-graph>
  </div>
</div>
